import { PayloadAction } from '@reduxjs/toolkit';
import { ApiResponse } from '../types/api';

export const isDispatchApiSuccess = <R extends ApiResponse = any, T extends PayloadAction<R> = PayloadAction<R>>(
  obj: T | unknown,
): obj is T => !!(obj as T)?.payload?.status && (obj as T)?.payload?.status === 'success';
